import React, { useEffect, useRef, useState, useMemo } from "react";
import "./TextToBold.css";
import "./ToolsAction.css";
import Alert from "./Alert";
import { ToastContainer, toast } from "react-toastify";
import { CustomFontSelector } from "./SelectBox";
import { Helmet } from "react-helmet";
import ScrollTag from "./ScrollTag";
import { ShareButton } from "./HandleShare";
import Tooltip from "./Tooltip";
import { detectCaption } from "./DetectCaption";
import CaptionStory from "./CaptionStory";
import { coffeeCaptions, generalCaptions, interiorCaptions, LovedCaptions, TravelCaptions, BirthdayCaptions, suggestedCaptions, FriendsCaptions, AttitudeCaptions, NatureCaptions } from "./SuggestedCaptions"
import { hashtagBank } from "./SuggestedHashTags";
import { Link, useLocation } from "react-router-dom";
import { ShowEndImageSection } from "./ShowEndImageSection";
import FAQ from "./FAQ";
import EmojiPicker from "emoji-picker-react";
// import { Smile } from "lucide-react";
import "./TextEmoji.css"
import { trackEvent } from "./UtilsFunction";

const CAPTION_TOPICS = [
  {
    label: "Love",
    emoji: "❤️",
    value: "love",
    captions: LovedCaptions,
  },
  {
    label: "Birthday",
    emoji: "🎂",
    value: "birthday",
    captions: BirthdayCaptions,
  },
  {
    label: "Friends",
    emoji: "🫶",
    value: "friends",
    captions: FriendsCaptions,
  },  
    {
    label: "Attitude",
    emoji: "😎",
    value: "attitude",
    captions: AttitudeCaptions,
  },

   {
    label: "Nature",
    emoji: "🌳",
    value: "nature",
    captions: NatureCaptions,
  },

  //  {
  //   label: "Travel",
  //   emoji: "✈️",
  //   value: "travel",
  //   captions: TravelCaptions,
  // },
  
];

const SEO_CONFIG = {
  "/tools/bold-text-generator": {
    title: "Bold Text & Bold Captions (𝑪𝒐𝒑𝒚 𝒂𝒏𝒅 𝑷𝒂𝒔𝒕𝒆) | BrowseNext",
    description:
      "Convert normal text into bold Unicode text instantly. Perfect for Instagram, WhatsApp, and social media.",
    canonical: "https://www.browsenext.today/tools/bold-text-generator",
    h1: "Bold Text Generator",
  },

  "/tools/bold-caption": {
    // title: "Bold Caption Generator - Create Bold Captions | BrowseNext",
    // title: "Bold Instagram Caption Generator | BrowseNext",
    title: "Bold Captions for Instagram | BrowseNext",

    // description: "Create bold captions for Instagram and others social media. Copy & paste stylish bold captions instantly.",
    description: "Create bold captions for Instagram and other social media. Write your caption, make it bold, and copy it instantly.",
    canonical: "https://www.browsenext.today/tools/bold-caption",
    h1: "Bold Caption Generator",
  },

  "/tools": {
    title: "Ready to Use Captions and Hashtags | BrowseNext",
    description:
      "Generate free captions, bold text, and trending hashtags for Instagram, WhatsApp, and social media. Copy & paste instantly using BrowseNext tools.",
    canonical: "https://www.browsenext.today/tools",
    h1: "Captions & Hashtags",

    // h1: "Style Your Captions",
  },
};

// Convert normal captions into bold social media text.


const TextToBold = (props) => {
  const [maps, setMaps] = useState({});
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const [selectedStyle, setSelectedStyle] = useState(null);
  let [userTyped, setUserTyped] = useState(false);
  const [hashtags, setHashtags] = useState("");
  const [showStory, setShowStory] = useState(false);
  const [storyText, setStoryText] = useState("");
  const hashTagRefText = useRef(null)
  // const location = useLocation();
  const location = useLocation();
  const seo = SEO_CONFIG[location.pathname] || SEO_CONFIG["/tools"];
  // const isBoldTextPage = location.pathname === "/tools/bold-text-generator";
  const isBoldTextPage = location.pathname.includes("bold-text-generator");
  const isTools = location.pathname.includes("tools");

  const isBoldCaptionPage = location.pathname === "/tools/bold-caption";
  const captionFromExplore = location.state?.captionText || "";
  const [selectedTag, setSelectedTag] = useState("");

  const [selectedTopic, setSelectedTopic] = useState(CAPTION_TOPICS[0]);
  // const [selectedTopic, setSelectedTopic] = useState(null);
  // const showToolsMessage = false
  const [showToolsMessage, setShowToolsMessage] = useState(false)
  const userStartedTyping = useRef(false);
  // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);




  const [showToolsInfo, setShowToolsInfo] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  const hideToolsInfo = () => {

    trackEventsNewFunction(
      "tools_hint_closed"
    );


    setIsClosing(true);

    setTimeout(() => {
      setShowToolsInfo(false);
    }, 300); // match animation duration
  };


  function trackEventsNewFunction(name, params = {}) {
    if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return

    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  }

  useEffect(() => {
    if (captionFromExplore) {
      // setInputText(captionFromExplore);
      setSelectedTag(captionFromExplore);
      highlightTags(captionFromExplore)
      console.log("caption from explore", captionFromExplore)
    }
  }, [captionFromExplore]);




  useEffect(() => {
    if (selectedTag) {
      console.log("selectedTag", selectedTag)
      setInputText(selectedTag)
      highlightTags(selectedTag)
    }
  }, [selectedTag]);





  function generateHashtags(caption) {
    const category = detectCaption(caption);
    let tags = hashtagBank[category] || [];

    tags = [
      ...tags,
      "#quoteoftheday", "#viralquote",
      "#motivationalquote", "#trendingnow"
    ];

    const unique = Array.from(new Set(tags)).slice(0, 10);
    // console.log("uniques captions", unique.join(" "))

    return unique.join(" ");
  }


  useEffect(() => {

    let userInputElement = document.getElementById('inputText')
    if (!inputText.trim() && userInputElement) {
      setHashtags("");
      return;
    }


    const tagString = generateHashtags(inputText);
    setHashtags(tagString);
    // userInputElement.focus()

  }, [inputText]);



  useEffect(() => {


    const createMap = (normal, styled) => {
      const map = {};

      Array.from(normal).forEach((char, index) => {
        map[char] = Array.from(styled)[index];
      });

      return map;
    };

    const normal =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

    const mapWords = {
      boldSerif: createMap(
        normal,
        "𝐀𝐁𝐂𝐃𝐄𝐅𝐆𝐇𝐈𝐉𝐊𝐋𝐌𝐍𝐎𝐏𝐐𝐑𝐒𝐓𝐔𝐕𝐖𝐗𝐘𝐙𝐚𝐛𝐜𝐝𝐞𝐟𝐠𝐡𝐢𝐣𝐤𝐥𝐦𝐧𝐨𝐩𝐪𝐫𝐬𝐭𝐮𝐯𝐰𝐱𝐲𝐳"
      ),

      boldSans: createMap(
        normal,
        "𝗔𝗕𝗖𝗗𝗘𝗙𝗚𝗛𝗜𝗝𝗞𝗟𝗠𝗡𝗢𝗣𝗤𝗥𝗦𝗧𝗨𝗩𝗪𝗫𝗬𝗭𝗮𝗯𝗰𝗱𝗲𝗳𝗴𝗵𝗶𝗷𝗸𝗹𝗺𝗻𝗼𝗽𝗾𝗿𝘀𝘁𝘂𝘃𝘄𝘅𝘆𝘇"
      ),

      italic: createMap(
        normal,
        "𝐴𝐵𝐶𝐷𝐸𝐹𝐺𝐻𝐼𝐽𝐾𝐿𝑀𝑁𝑂𝑃𝑄𝑅𝑆𝑇𝑈𝑉𝑊𝑋𝑌𝑍𝑎𝑏𝑐𝑑𝑒𝑓𝑔ℎ𝑖𝑗𝑘𝑙𝑚𝑛𝑜𝑝𝑞𝑟𝑠𝑡𝑢𝑣𝑤𝑥𝑦𝑧"
      ),

      boldItalic: createMap(
        normal,
        "𝑨𝑩𝑪𝑫𝑬𝑭𝑮𝑯𝑰𝑱𝑲𝑳𝑴𝑵𝑶𝑷𝑸𝑹𝑺𝑻𝑼𝑽𝑾𝑿𝒀𝒁𝒂𝒃𝒄𝒅𝒆𝒇𝒈𝒉𝒊𝒋𝒌𝒍𝒎𝒏𝒐𝒑𝒒𝒓𝒔𝒕𝒖𝒗𝒘𝒙𝒚𝒛"
      ),

      script: createMap(
        normal,
        "𝒜ℬ𝒞𝒟ℰℱ𝒢ℋℐ𝒥𝒦ℒℳ𝒩𝒪𝒫𝒬ℛ𝒮𝒯𝒰𝒱𝒲𝒳𝒴𝒵𝒶𝒷𝒸𝒹ℯ𝒻ℊ𝒽𝒾𝒿𝓀𝓁𝓂𝓃ℴ𝓅𝓆𝓇𝓈𝓉𝓊𝓋𝓌𝓍𝓎𝓏"
      ),

      fraktur: createMap(
        normal,
        "𝔄𝔅ℭ𝔇𝔈𝔉𝔊ℌℑ𝔍𝔎𝔏𝔐𝔑𝔒𝔓𝔔ℜ𝔖𝔗𝔘𝔙𝔚𝔛𝔜ℨ𝔞𝔟𝔠𝔡𝔢𝔣𝔤𝔥𝔦𝔧𝔨𝔩𝔪𝔫𝔬𝔭𝔮𝔯𝔰𝔱𝔲𝔳𝔴𝔵𝔶𝔷"
      ),

      doubleStruck: createMap(
        normal,
        "𝔸𝔹ℂ𝔻𝔼𝔽𝔾ℍ𝕀𝕁𝕂𝕃𝕄ℕ𝕆ℙℚℝ𝕊𝕋𝕌𝕍𝕎𝕏𝕐ℤ𝕒𝕓𝕔𝕕𝕖𝕗𝕘𝕙𝕚𝕛𝕜𝕝𝕞𝕟𝕠𝕡𝕢𝕣𝕤𝕥𝕦𝕧𝕨𝕩𝕪𝕫"
      ),

      monospace: createMap(
        normal,
        "𝙰𝙱𝙲𝙳𝙴𝙵𝙶𝙷𝙸𝙹𝙺𝙻𝙼𝙽𝙾𝙿𝚀𝚁𝚂𝚃𝚄𝚅𝚆𝚇𝚈𝚉𝚊𝚋𝚌𝚍𝚎𝚏𝚐𝚑𝚒𝚓𝚔𝚕𝚖𝚗𝚘𝚙𝚚𝚛𝚜𝚝𝚞𝚟𝚠𝚡𝚢𝚣"
      ),
    };

    setMaps(mapWords);
    setSelectedStyle({
      label: "Bold (Sans)",
      value: "boldSans",
    });
  }, []);

  useEffect(() => {
    if (!maps || !selectedStyle) return;

    const map = maps[selectedStyle.value];
    if (!map) return;

    const output = inputText
      .split("")
      .map((c) => map[c] || c)
      .join("");

    setOutputText(output);

    const outputEl = document.getElementById("output");
    if (outputEl) {
      if (inputText.trim()) {
        outputEl.classList.add("bold_output");
      } else {
        outputEl.classList.remove("bold_output");
      }
    }
  }, [inputText, maps, selectedStyle]);

  function trackEvents(forWhich, type, text) {
    if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;

    // 🔥 Google Analytics
    if (window.gtag) {
      window.gtag("event", type, {
        action_type: forWhich === "Caption" ? `copy_caption::${text}` : `copy_hashtags::${text}`,
        from: window.location.pathname || "/tools",
        deviceWidth : `${timeForPage()}-${window.location.pathname}`,
      });
    }


  }


  const copyOutput = (forWhich) => {
    let text;
    if (forWhich === "Caption") {
      const captionText = document.getElementById("output").value;
      text = captionText

    } else {
      const hashtagText = hashTagRefText.current.innerText
      text = hashtagText
    }

    navigator.clipboard.writeText(text).then(() => {
      if (isBoldTextPage) {
        toast.success(`Bold text copied to clipboard!`);
        trackEvents("bold-text", "copy_action", text)

      } else {

        toast.success(`${forWhich} copied to clipboard!`);
        trackEvents(forWhich, "copy_action", text)
      }
    });
  };


  function highlightTags(initialText) {
    const tagNames = document.querySelectorAll('.app_blog_tag_text');
    tagNames.forEach((tag) => {
      if (tag.innerText === initialText) {
        tag.classList.add('highlight_tag');
      } else {
        tag.classList.remove('highlight_tag');
      }
    });
  }

  //   useEffect(() => {
  //   if (document.getElementById('inputText')) {
  //     // document.getElementById('inputText').focus();
  //     // displayDynamicBlogs()
  //     // setInputText(suggestedCaptions[0])


  // if (!captionFromExplore) {
  //   // setSelectedTag(suggestedCaptions[0]);
  //   // setSelectedTag(LovedCaptions[0]);
  //    setSelectedTag(selectedCaptions[0]);
  // }

  //     // highlightTags(suggestedCaptions[0])

  //      // Dynamically apply media query
  //     const style = document.createElement('style');
  //     style.innerHTML = `
  //       @media screen and (max-width: 680px) { 
  //         .st_blog_tag_suggestion {
  //           display: flex !important;
  //         }
  //       }
  //         .app_blog_tag_text{
  //         color: #160b0b;
  //         }
  //     `;
  //     document.head.appendChild(style);

  //     // Optional: clean up style when component unmounts
  //     return () => {
  //       document.head.removeChild(style);
  //     };
  //   }

  // }, [selectedCaptions, captionFromExplore]);

  // Remove highlight if user types
  useEffect(() => {
    if (userTyped) {
      const tagNames = document.querySelectorAll(".app_blog_tag_text");
      tagNames.forEach((tag) => {
        tag.classList.remove("highlight_tag");
      });
    }
  }, [inputText, userTyped]);

  function handleTagClick(tag) {
    console.log("tag", tag)
    trackEventsNewFunction("suggested_caption_click",
      {
        caption_text: tag
      }
    );
    userStartedTyping.current = false
    setSelectedTag(tag)
    setInputText(tag)
    setShowToolsMessage(false)
  }

  function sendClickFeed(event, element) {
    let shareButton = event.target;
    console.log("this", element)
    // console.log("document.title in home", featuredStoredImage)
    if (shareButton) {
      // buttonRef.current.style.backgroundColor = "#000000b8";
      // shareButton.firstElementChild.style.color = "white";
      shareButton.style.transition = "all 0.05s linear";
      shareButton.style.transform = "scale(0.9)";

      // shareButton.firstElementChild.style.backgroundColor = "white";
    }

  }
  function removeClickFeed(event) {
    let shareButton = event?.target;

    if (shareButton) {
      // buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";
      // shareImage(imageUrl)
      // showBlog();
      // shareButton.style.backgroundColor = "";

    }

  }
  function orignalElement(event) {
    let shareButton = event?.target;
    if (shareButton) {
      // buttonRef.current.style.backgroundColor = "black";
      shareButton.style.transform = "scale(1)";
      // shareButton.firstElementChild.style.color = "";         
    }
  }


  // function shuffleArray(array) {
  //   return array.sort(() => Math.random() - 0.5);
  // }

  useEffect(() => {

    if (isBoldTextPage) {
      setInputText("")
    } else if (isBoldCaptionPage) {

      setInputText(selectedCaptions[0])      // for the blod page


    }

  }, [location.pathname])

  const shuffleArray = useMemo(() => {
    return [...suggestedCaptions, ...generalCaptions, ...interiorCaptions, ...coffeeCaptions].sort(() => Math.random() - 0.5);
    return [...suggestedCaptions, ...generalCaptions, ...interiorCaptions, ...coffeeCaptions]
    return [...LovedCaptions, ...generalCaptions]
  }, []);

  const selectedCaptions = useMemo(() => {
    if (!selectedTopic) {
      return [...LovedCaptions, ...generalCaptions];
    }

    return selectedTopic.captions;
  }, [selectedTopic]);


  useEffect(() => {
    if (document.getElementById('inputText')) {
      // document.getElementById('inputText').focus();
      // displayDynamicBlogs()
      // setInputText(suggestedCaptions[0])


      if (!isBoldTextPage && !captionFromExplore && !inputText.trim()) {


        setSelectedTag(selectedCaptions[0]);    // to show the initally cpation 
      }


    }

  }, [selectedCaptions]);


  useEffect(() => {

    if (document.getElementById('inputText')) {

      const style = document.createElement('style');

      style.innerHTML = `

      @media screen and (max-width: 680px) { 
        .st_blog_tag_suggestion {
          display: flex !important;
        }
      }

      .app_blog_tag_text {
        color: #160b0b;
      }

    `;

      document.head.appendChild(style);

      return () => {
        document.head.removeChild(style);
      };

    }

  }, []);

  const handleTopicClick = (topic) => {
    setSelectedTopic(topic);

    // Auto-select caption only after user manually selects a topic
    if (topic?.captions?.length && !inputText.trim()) {
      setSelectedTag(topic.captions[0]);
      console.log("wiht fill input", inputText)
    }
    console.log("wihtout fill input", inputText)
    trackEventsNewFunction("caption_topic_selected", {
      topic: topic.value,
    });
  };



  function captionTopicCapitalize(captionTopic) {
    if (!captionTopic) return

    const cleanTitle = decodeURIComponent(captionTopic).replace(/-/g, " ");

    return cleanTitle.charAt(0).toUpperCase() + cleanTitle.slice(1)
  }



  return (
    <>
      <Helmet>
        <title>{seo.title}</title>

        <meta name="description" content={seo.description} />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="BrowseNext" />

        {/* CANONICAL (CRITICAL FOR SEO) */}
        <link rel="canonical" href={seo.canonical} />

        {/* Open Graph */}
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:image" content="https://www.browsenext.today/favicons.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content="https://www.browsenext.today/favicons.png" />
      </Helmet>


      {/* <div className={`container app_container text_to_bold_container ${ props.fromWhere !== "tools" ? "mt-ps90" : "" }`}> */}
      <div className={`container app_container text_to_bold_container`}>
        <div className="tool_header">
          <div className="bold_caption_heading_container">
            <h1 className="app_tool_heading tool_inside_header">
              {/* {isBoldTextPage ? "Bold Text Generator" : "Bold Captions"} */}
              {seo.h1}
            </h1>
            {/* <span class="last_updated_text">for your social media posts</span> */}

            {!isBoldCaptionPage && !isBoldTextPage && (
              <span className="last_updated_text">
                {/* Choose a topic. Get captions instantly. Copy and post. */}
                Choose a topic, find a caption that fits your image, then copy it to post.
              </span>
            )}

            {isBoldCaptionPage && (
              <span className="last_updated_text">
                Create stylish bold captions for your social media posts.
              </span>
            )}
          </div>
          {(selectedTopic && selectedStyle) && (
            <CustomFontSelector
              selected={selectedStyle}
              onSelect={setSelectedStyle}
              //               onSelect={(style) => {
              //   if (!inputText.trim() && selectedCaptions?.length) {
              //     setSelectedTag(selectedCaptions[0]);
              //   }

              //   setSelectedStyle(style);
              // }}
              hasText={Boolean(inputText.trim())}
            />
          )}

        </div>
        {!isBoldTextPage && (
          <>
            <div className={`suggested_caption_hashtags app_container ${!selectedTopic ? 'minus_margin_bottom' : ''}`}>

              {/* Topic Selection */}

              <div className="caption_topic_section">

                <span className="last_updated_text tools_black_text suggested_captions">
                  What are you posting about?
                </span>

                <div className="caption_topic_list">

                  {CAPTION_TOPICS.map((topic) => (
                    <button
                      key={topic.value}
                      className={`caption_topic_button ${selectedTopic?.value === topic.value
                          ? "active_topic"
                          : ""
                        }`}
                      onClick={() => {
                        handleTopicClick(topic);


                      }}
                    >
                      {topic.label} {topic.emoji}
                    </button>
                  ))}

                </div>

              </div>

              {/*................. Suggested Captions */}
              {selectedTopic && (<>
                <span className="last_updated_text tools_black_text suggested_captions adjust_bottom_fortools">Suggested Captions for {captionTopicCapitalize(selectedTopic?.value)}</span>

                <ScrollTag whereFrom="captions" tagList={selectedCaptions} arrowButonnClass={'hide_from_mobile'}

                  //selectedTag={captionFromExplore}
                  selectedTag={selectedTag}
                  onTagClick={handleTagClick}
                />

              </>)}


              {/* {(hashtags && !isBoldCaptionPage) && (
        <div className="hashtags-box blog_tag_suggestion hashtags_area">
  <p className="user_textarea_input set_min_content" ref={hashTagRefText}>{hashtags}</p>

  
    <button className="hashtags_copy_button"   tabIndex={0} onClick={()=>copyOutput("Hashtags")}
    onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    copyOutput("Hashtags");
                  }
                }}

                onMouseDown={(e)=>sendClickFeed(e)} onMouseUp={(e)=>removeClickFeed(e)} onMouseOut={(e)=>orignalElement(e)}
           onTouchStart={(e) => sendClickFeed(e)}
  onTouchEnd={(e) => removeClickFeed(e)}
  onTouchCancel={(e) => orignalElement(e)}
    >
      Copy Hashtags 
      
    </button>
</div>
  )} */}

            </div>
          </>

        )}

        {/* && !isMobile  */}
        {((showToolsMessage && isTools && !isBoldTextPage) && showToolsInfo) && (
          <div className={`tools_container_info ${isClosing ? "tools_container_info_hide" : ""
            }`}>
            {/* <span className="last_updated_text">Type your caption in the left box and preview bold text in the right box.</span> */}

            {/* <span className="last_updated_text tools_black_text">You can also type your own caption on left or click any <span className="suggsted_suggest">&nbsp;Suggested Captions&nbsp;</span> to make it yours.</span> */}

            {/* <span className="last_updated_text tools_black_text">Type your own caption or choose a <span className="suggsted_suggest">&nbsp;suggested captions&nbsp;</span> to get started.</span> */}


            {/* <span className="last_updated_text tools_black_text">Choose a topic to discover caption ideas</span> */}
            <span className="last_updated_text tools_black_text">Choose a suggested caption to start, or write your own.</span>

            <i
              className="fa-solid fa-xmark explore_purposetext_close home_status_close_button"
              // onClick={hideDiscoverlyNote}
              onClick={hideToolsInfo}
            ></i>
          </div>

        )}
        <div className="col_textTobold_output mt-1">
          <div className="input_div position-relative">

            {/* {inputText.trim() && 
            (
              <div class="caption_tool_actions">
           <Tooltip text="Copy" position="bottom">
              <i
               role="button"
              tabIndex={0}
              aria-label={`Copy bold Text`}
                className="fa-regular fa-camera copy_bold_texticon outline-none"
                onClick={()=>{
                   setStoryText(outputText);   // ← this should be your generated bold text
                   setShowStory(true);
                }}
             
              ></i>
              </Tooltip> 
              </div>
           )} */}
            <textarea
              className="user_textarea_input"
              id="inputText"

              // placeholder="Enter caption that you want to bold..."
              placeholder={isTools && !isBoldTextPage
                ? "Choose a suggested caption or write your own caption to get started"
                : "Enter caption that you want to bold..."}

              value={inputText}
              onKeyDown={(e) => {
                if (!userStartedTyping.current && e.key.length === 1) {

                  console.log("🔥 USER STARTED TYPING");

                  trackEvents(
                    "TypeInputBox",
                    "user_typeon_input",
                    "user_typed"
                  );

                  userStartedTyping.current = true;
                }
              }}
              onChange={(e) => {
                const value = e.target.value;


                setInputText(e.target.value)
                setUserTyped(true);
                setShowToolsMessage(false)
              }

              }
            />

            {(!isBoldTextPage && !isMobile) && <span className="position-absolute info_text">Copy a suggested caption  or Type your own caption </span>}
            <EmojiBox  inputText={inputText} setInputText={setInputText} setUserTyped={setUserTyped}  />
          </div>

          <div className="bold_text_ouput input_div position-relative">
            {inputText.trim() &&
              (
                <div class="caption_tool_actions">
                  <Tooltip text="Copy" position="bottom">
                    <i
                      role="button"
                      tabIndex={0}
                      aria-label={`Copy bold Text`}
                      className="fa-solid fa-copy copy_bold_texticon outline-none"
                      onClick={() => copyOutput("Caption")}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          copyOutput("Caption");
                        }
                      }}
                      onMouseDown={(e) => sendClickFeed(e)} onMouseUp={(e) => removeClickFeed(e)} onMouseOut={(e) => orignalElement(e)}
                      onTouchStart={(e) => sendClickFeed(e)}
                      onTouchEnd={(e) => removeClickFeed(e)}
                      onTouchCancel={(e) => orignalElement(e)}
                    ></i>
                  </Tooltip>

                  {/* <i
               role="button"
              tabIndex={0}
              aria-label={`Copy bold Text`}
                className="fa-solid fa-copy copy_bold_texticon outline-none"
                onClick={copyOutput}
                 onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    copyOutput();
                  }
                }}
              ></i> */}
                  <Tooltip text="Share" position="bottom">
                    <ShareButton btnClass={"copy_bold_texticon"} productTitle={"✨ BrowseNext – Free Bold Caption for Social Media ✨"} productDesc={"Make your captions bold & stylish instantly! then just copy & paste... Try now:"} callingFrom={"captionTools"} whereFrom="BoldTextTools" />
                  </Tooltip>

                </div>


              )}
            <textarea
              id="output"
              className="user_textarea_input"
              readOnly
              placeholder="Bold caption will appear here..."
              value={outputText}
               onCopy={(e) => {
    const textarea = e.currentTarget;

    const copiedText = textarea.value.substring(
      textarea.selectionStart,
      textarea.selectionEnd
    );

    if (!copiedText.trim()) return;

    trackEvents(
      "Caption",
      "copy_action",
      copiedText
    );
  }}
            />
          </div>
        </div>

        {(hashtags && !isBoldCaptionPage) && (
          <div className="hashtags-box blog_tag_suggestion hashtags_area">
            <p className="user_textarea_input set_min_content" ref={hashTagRefText}>{hashtags}</p>


            <button className="hashtags_copy_button" tabIndex={0} onClick={() => copyOutput("Hashtags")}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  copyOutput("Hashtags");
                }
              }}

              onMouseDown={(e) => sendClickFeed(e)} onMouseUp={(e) => removeClickFeed(e)} onMouseOut={(e) => orignalElement(e)}
              onTouchStart={(e) => sendClickFeed(e)}
              onTouchEnd={(e) => removeClickFeed(e)}
              onTouchCancel={(e) => orignalElement(e)}
            >
              Copy Hashtags

            </button>
          </div>
        )}

      </div>

      <FAQ />

      {(isBoldTextPage) && (<>
        <div className="container bottom_tools_container">
          <div className="inside_container_tool">
            <h2 className="app_home_feeds_heading mb-0">Explore More Tools</h2>
            <p className="last_updated_text mt-1 tool_p">
              Create, style, and prepare your captions with hashtags on BrowseNext tools.
            </p>
            <div className="tool_bottom_action">

              <Link className="hashtags_copy_button explore_tools" to={"/tools/bold-caption"} tabIndex={0}


                onMouseDown={(e) => sendClickFeed(e)} onMouseUp={(e) => removeClickFeed(e)} onMouseOut={(e) => orignalElement(e)}
                onTouchStart={(e) => sendClickFeed(e)}
                onTouchEnd={(e) => removeClickFeed(e)}
                onTouchCancel={(e) => orignalElement(e)}>Bold Caption Generator</Link>

              <Link className="hashtags_copy_button explore_tools" to={"/tools"} tabIndex={0}


                onMouseDown={(e) => sendClickFeed(e)} onMouseUp={(e) => removeClickFeed(e)} onMouseOut={(e) => orignalElement(e)}
                onTouchStart={(e) => sendClickFeed(e)}
                onTouchEnd={(e) => removeClickFeed(e)}
                onTouchCancel={(e) => orignalElement(e)}>Try Caption & Hashtags</Link>
            </div>

          </div>

        </div>



      </>)}

      {/* <Alert position="bottom-center" /> */}
      {(isTools || isBoldTextPage || isBoldCaptionPage) && (
        <>

          <ShowEndImageSection fetchSavedImages={props.fetchSavedImages} componentFrom="text-to-bold" />

        </>
      )



      }

      {showStory && (
        <div className="story-modal">
          <div className="story-backdrop" onClick={() => setShowStory(false)} />

          {/* <div className="story-box">
      <CaptionStory initialText={storyText} />
    </div> */}
        </div>
      )}




    </>
  );
};

export default TextToBold;


function EmojiBox(props) {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiPickerRef = useRef(null);
const [showEmojiButton, setShowEmojiButton] = useState(false);

useEffect(() => {
  const timer = setTimeout(() => {
    setShowEmojiButton(true);
  }, 2000);

  return () => clearTimeout(timer);
}, []);

  // Close when clicking outside the button and picker
  useEffect(() => {
    if (!showEmojiPicker) return;

    const handleOutsideClick = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
  if (!showEmojiPicker) return;

  const timer = setTimeout(() => {
    const searchInput = document.querySelector(
      ".emoji-picker-popover input"
    );
   

    if (searchInput === document.activeElement) {
      searchInput.blur();
    }
  }, 5);

  return () => clearTimeout(timer);
}, [showEmojiPicker]);

  // Close on mobile scroll
 useEffect(() => {
  const handleScroll = (event) => {
    if (window.innerWidth > 768) return;

    // Keep the picker open when scrolling inside it
    if (
      emojiPickerRef.current &&
      emojiPickerRef.current.contains(event.target)
    ) {
      return;
    }

    setShowEmojiPicker(false);
  };

  window.addEventListener("scroll", handleScroll, true);

  return () => {
    window.removeEventListener("scroll", handleScroll, true);
  };
}, []);

  const handleEmojiClick = (emojiData) => {
    const emoji = emojiData.emoji;
    const textarea = document.getElementById("inputText");
     

    if (!textarea) return;

    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;

    const newText =
      props.inputText.slice(0, start) +
      emoji +
      props.inputText.slice(end);

    props.setInputText(newText);
    props.setUserTyped(true);
    trackEvent("set_emoji_in_inputbox",{
      deviceWidth : `${timeForPage()}-${window.location.pathname}`,
      
    })

    // Do not close the picker after selecting an emoji
    // requestAnimationFrame(() => {
    //   // textarea.focus();
    //   // const cursor = start + emoji.length;
    //   // textarea.setSelectionRange(cursor, cursor);
    // });
  };

  return (
    <div ref={emojiPickerRef} className="emoji-picker-wrapper">
    {showEmojiButton && (
  <button
    type="button"
    className={
      showEmojiPicker
        ? "open_emoji_picker emoji-picker-button"
        : "emoji-picker-button"
    }
    aria-label="Insert emoji"
    title="Click to add emoji"
    onClick={() => {
      setShowEmojiPicker(prev => !prev);
      trackEvent("click_emoji_button",{
        deviceWidth : `${timeForPage()}-${window.location.pathname}`,
      })
    }}
  >
    {showEmojiPicker ? (
      <i className="fa-solid fa-xmark"></i>
    ) : (
      "😊"
      // <i class="fa-solid fa-face-grin-hearts" style={{padding: "5px 5px 4px 5px"}}></i>
    )}
  </button>
)}

      {showEmojiPicker && (
        <div className="emoji-picker-popover">
          <EmojiPicker
            onEmojiClick={handleEmojiClick}
            width="100%"
            height={350}
          />
        </div>
      )}
    </div>
  );
}

function timeForPage(){
  const arrivalTime = new Date();
    const deviceWidth = window.innerWidth;
  const deviceType = deviceWidth <= 768 ? "mobile" : "desktop";
   const time = arrivalTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  })

  return `${deviceWidth}-${deviceType}-${time}`
}